import React, { Component } from "react";
import PropTypes from "prop-types";

import { FieldArray, getIn } from "formik";
import {
  FieldLabel,
  GroupField,
  TextField,
} from "react-invenio-forms";
import { Button, Form, Icon } from "semantic-ui-react";


export class ValuationField extends Component {
  renderArray = ({ form: { values }, ...arrayHelpers }) => {
    const {
      fieldPath,
      label,
      icon,
      placeholder,
      description,
      addButtonLabel,
    } = this.props;

    const valuations = getIn(values, fieldPath, []) || [];

    return (
      <Form.Field>
        <FieldLabel
          htmlFor={fieldPath}
          icon={icon}
          label={label}
        />

        {valuations.map((value, index) => (
          <GroupField optimized key={`${fieldPath}.${index}`}>
            <TextField
              fieldPath={`${fieldPath}.${index}`}
              label="Valuation value"
              placeholder={placeholder}
              width={16}
            />

            <Form.Field>
              <Button
                type="button"
                aria-label="Remove valuation"
                className="close-btn"
                icon
                onClick={() => arrayHelpers.remove(index)}
              >
                <Icon name="close" />
              </Button>
            </Form.Field>
          </GroupField>
        ))}

        {description && (
          <label className="helptext">
            {description}
          </label>
        )}

        <Form.Group>
          <Form.Button
            type="button"
            icon
            className="align-self-end mt-15"
            labelPosition="left"
            onClick={() => arrayHelpers.push("")}
          >
            <Icon name="add" />
            {addButtonLabel}
          </Form.Button>
        </Form.Group>
      </Form.Field>
    );
  };

  render() {
    const { fieldPath } = this.props;

    return (
      <FieldArray
        className="invenio-array-field"
        name={fieldPath}
        id={fieldPath}
        component={this.renderArray}
      />
    );
  }
}


ValuationField.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  label: PropTypes.string,
  icon: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  addButtonLabel: PropTypes.string,
};


ValuationField.defaultProps = {
  label: "Valuation",
  icon: "tag",
  placeholder: "Valuation...",
  description: "",
  addButtonLabel: "Add valuation",
};


export default ValuationField;
